import _DTO from "./_DTO";
import ConfigurationDTO from "./ConfigurationDTO";

export default class SoftwareLicenceDTO extends _DTO {

  constructor(softwareLicence) {
    super();
    this.id = softwareLicence.id;
    this.quantity = softwareLicence.quantity;
    this.licenceGroup = softwareLicence.licenceGroup;
    this.licenceCategory = softwareLicence.licenceCategory;
    this.configuration = SoftwareLicenceDTO.getMappedOrDefault(softwareLicence, 'configuration', null, data => new ConfigurationDTO(data));
    this.selectorOrigin = softwareLicence.selectorOrigin;
  }
}
